import NotitieBlock from "../components/blocks/NotitieBlock";

const NotitiesOverview = () => {

    return (<>
        <NotitieBlock/>
    </>)
}
export default NotitiesOverview